<template>
  <div class="tab-six-cv">
    <div>
      <el-alert title="" type="error">
        其他文书处上传学生自己准备的文书
      </el-alert>
      <el-form class="form-wrapper" label-width="80px">
        <el-button size="small" type="primary" @click="addDocumentCVU"
        >新增</el-button
        >
      </el-form>

      <el-table v-loading="loading" :data="lists" style="width: 100%">
        <el-table-column prop="d1" label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{
              (requestData.page - 1) * requestData.paginate + (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column label="文书" prop="" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.name">
              <el-link
                type="primary"
                @click="
                  () => {
                    previewUrl = scope.row.upload_documents[0].url;
                    previewName = scope.row.upload_documents[0].name;
                  }
                "
              >
                预览/下载
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" align="center"> </el-table-column>
<!--        <el-table-column label="文书记录" prop="" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-link type="primary" @click="logDocumentCVU(scope.row)"-->
<!--            >查看</el-link-->
<!--            >-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="updated_at" label="更新时间" align="center" />
        <el-table-column label="操作" prop="" align="center" width="120">
          <template slot-scope="scope">
            <div class="btns-wrapper">
              <el-button
                class="btn"
                size="mini"
                @click="editDocumentCVU(scope.row)"
                type="primary"
              >修改</el-button
              >
              <el-popconfirm
                title="是否确定删除该数据？"
                @confirm="delDocumentCVU(scope.row.id)"
              >
                <el-button
                  class="btn"
                  slot="reference"
                  size="mini"
                  type="danger"
                >删除</el-button
                >
              </el-popconfirm>
            </div>


          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--文书上传弹窗-->
    <show_document  ref="showDocument" />
    <!--文书显示弹窗-->
    <upload_document ref="uploadDocument" @show_list="getList" />
    <reject ref="reject" @reject="getList" :needFile="true"></reject>
    <reason_rejection ref="reason_rejection"></reason_rejection>
    <HBFilePreview
      buttonType="document"
      :previewUrl="previewUrl"
      :fileName="previewName"
      @updateVisible="
        previewUrl = null;
        previewName = null;
      "
    />
    <el-dialog
      center
      title="查看"
      :visible="detailInfoDialog"
      width="50%"
      :before-close="() => (detailInfoDialog = null)"
    >
      <p style="white-space: pre-wrap; font-size: 16px">
        {{ detailInfoDialog }}
      </p>
    </el-dialog>
  </div>
</template>
<script>
import {
  document_list,
  del_document,
  user_information_document_edit,
} from "@/api/mycenter_studyabroad";
import { downloadFile } from "@/api/file";
import show_document from "./show_document";
import upload_document from "./upload_document";
import reject from "./reject";
import reason_rejection from "./reason_rejection.vue";
import HBFilePreview from "@/components/HBCommon/HBFilePreview/HBFilePreview.vue";
export default {
  name: "TabSixCv",
  components: {
    reject,
    reason_rejection,
    show_document,
    upload_document,
    HBFilePreview,
  },
  data() {
    return {
      loading: '',
      local_filter_state: [],
      detailInfoDialog: null,
      previewUrl: null,
      previewName: null,
      infoListDialogDataSource: [],
      dialogAddUserSchoolChoice: false,
      dataSource: [],
      lists: [], // 数据列表
      page: {
        total: 100000, // 总条数
        currentPage: 1
      },
      addUserSchoolChoiceData: {
        remark: ''
      },
      reject_url: '',
      addMessage: {
        id: '',
        content: ''
      },
      TaskMessageVisible: false,
      requestData: {
        page: 1, // 当前页
        paginate: 15, // 分页大小
        templates_id: '',
        type: 'cvu',
        loading: ''
      },
      content: {
        title: '',
        type: '',
        name: '',
        operate: '',
        id: ''
      }
    };
  },
  computed: {
    kStateOptions() {
      return [
        {
          label: "已驳回",
          value: 2,
        },
        {
          label: "待确认",
          value: 3,
        },
        {
          label: "已确认",
          value: 1,
        },
        {
          label: "待老师上传",
          value: 0,
        },
      ];
    },
  },
  created() {
    this.getList(true);
  },
  methods: {
    editDocumentCVU(content) {
      this.content.type = "cvu";
      this.content.id = content.id;
      this.content.name = content.name.substring(0, content.name.indexOf("-"));
      this.content.operate = "edit";
      this.content.title = "修改文件";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    addDocumentCVU() {
      this.content.type = "cvu";
      this.content.operate = "add";
      this.content.title = "添加文件";
      this.content.id = "";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    delDocumentCVU(id) {
      del_document({ id: id, type: "cvu" }).then((response) => {
        this.getList(true);
      });
    },
    updateStatus(id,status) {
      user_information_document_edit({ 'id': id, 'status': status, 'type': 'rp' }).then(()=> {
        this.$message.success('状态更新成功')
        this.getList(true)
      }).catch(error=> {
        this.$message.error(error.message)
      })
    },
    downLoad(url, name) {
      downloadFile(url, name);
    },
    showDetailDialogContent(content,reject_type) {
      // var con = JSON.parse(item);
      // this.reject_url = con.url;
      // var str = con.content;
      // if(reject_type){
      //   str = reject_type + ' | ' + str
      // }
      // this.infoListDialogDataSource = [
      //   { label: "驳回原因", content: str },
      // ];
      content = JSON.parse(content);
      this.$refs.reason_rejection.sendItem(content.content, content.url,reject_type);

    },
    getList(isRefresh) {
      // // 获取列表
      // if (isRefresh) {
      //   this.requestData.page = 1
      // }
      this.loading = true;
      document_list(this.requestData).then((response) => {
        this.loading = false;
        const dataList = response.data || [];
        this.dataSource = dataList;
        this.lists = dataList;
        this.filterAction();
      });
    },
    logDocumentRP(content) {
      this.$refs.showDocument.sendItem(content.upload_documents);
    },

  },
};
</script>
<style lang="scss" scoped>
.tab-six-cv {
  .form-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .btn {
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_six_cvu.vue